<template>
    <div class="dialog" v-show="showMask">
        <div class="dialog-container">
            <div class="title_line_1"></div>
            <div class="dialog-title">{{title}}</div>
            <div class="title_line"></div>
            <div class="flex-between">
                <div class="flex-align-center top_layout">
                    <p class="ecg_p_text_1">姓名:</p>
                    <p class="ecg_p_text_2">{{user.name}}</p>
                    <p class="ecg_p_text_3">性别:</p>
                    <p class="ecg_p_text_2">{{user.sex===0?"女":"男"}}</p>
                    <p class="ecg_p_text_1">年龄:</p>
                    <p class="ecg_p_text_2">{{user.age}}</p>
                </div>

                <div class="flex-align-center right_layout">
                    <a-button type="primary" @click.native="saveToPc">保存图片结果</a-button>
                    <a-button type="primary" @click.native="saveRawData">保存原始数据</a-button>
                    <p class="ecg_p_text_4">Qt:</p><p class="ecg_p_text_1">{{qt}}ms</p>
                    <p class="ecg_p_text_4">Qtc:</p><p class="ecg_p_text_1">{{qtc}}ms</p>
                    <p class="ecg_p_text_4">P-R:</p><p class="ecg_p_text_1">{{pr}}ms</p>
                    <p class="ecg_p_text_4">QRS:</p><p class="ecg_p_text_1">{{qrs}}ms</p>
                </div>
            </div>
            <GeminiScrollbar id="scrollbar_view"
                    class="my-scroll-bar">
            <div class="content"  v-html="content" id="ecg_dialog_chart"> </div>
            <div class="content" v-html="content" id="ecg_dialog_chart1"> </div>
            <div class="content" v-html="content" id="ecg_dialog_chart2"> </div>
            <div class="content" v-html="content" id="ecg_dialog_chart3"> </div>
            <!--<div class="content" v-html="content" id="ecg_dialog_chart4"> </div>-->
            </GeminiScrollbar>
            <div class="close-btn" @click="closeMask">
                <img src="../../assets/ecg_dialog_2x.png" class="dismiss-dialog"/>
            </div>

            <div class="flex-between">
                <div class="flex-align-center top_layout">
                    <p class="ecg_p_text_2">诊断结论:</p>
                    <p class="ecg_p_text_3">{{ecgAi}}</p>
                </div>

                <div class="flex-align-center right_layout">
                    <p class="ecg_p_text_2">检查时间:</p><p class="ecg_p_text_1">{{ecgTime}}</p>
                </div>
            </div>

            <div class="flex-align-center top_layout">
                <p class="ecg_p_ai_result_1 flex-align">注：以上诊断由人工智能诊断算法Cardiolearn给出，供参考，请以医院确诊结论为准。</p>
            </div>
        </div>

    </div>
</template>
<script>
import ElectrocardiogramD from "../../graph/ElectrocardiogramD.js"
import html2canvas from 'html2canvas';
import Vue from 'vue'
import GeminiScrollbar from 'vue-gemini-scrollbar'

Vue.use(GeminiScrollbar)
export default {
    props: {
        value: {},
        qt:"",
        qtc:"",
        pr:"",
        qrs:"",
        ecgAi:"",
        user:"",

        type:{
            type: String,
            default: 'default'
        },
        content: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        flag:{
            type:Boolean,
            default:false
        },

        ecgTime:{
            type: String,
            default: ''
        },

        ecgAlertData:{
            type:Array,
            default:[]
        },

        ecgDeviceData:{
            type:String,
            default:""
        }
        ,
        link:"http://api7.iwown.com/dong2cal/"

    },
    data(){
        return{
            showMask: false,
            cancelDialog:false,
            ecgView:"",
            ecgView1:"",
            ecgView2:"",
            ecgView3:"",
            ecgView4:"",
        }
    },

    methods:{
        closeMask(){
            this.showMask = false;
            this.cancelDialog=true;
        },
        loadECGView(){
            this.ecgView=new ElectrocardiogramD(document.getElementById('ecg_dialog_chart'));
            this.ecgView1=new ElectrocardiogramD(document.getElementById('ecg_dialog_chart1'));
            this.ecgView2=new ElectrocardiogramD(document.getElementById('ecg_dialog_chart2'));
            this.ecgView3=new ElectrocardiogramD(document.getElementById('ecg_dialog_chart3'));
        },
        async  loadEcgDataDialog() {
            let ecg=this.ecgView;
            console.log('loadEcgDataDialog: ',this.ecgTime);
            
            let anotherEcg;
            anotherEcg=this.ecgAlertData;
            let ecgItem=anotherEcg.slice(0,1750);
            console.log('loadEcgDataDialog: ',ecgItem);
            ecg.setEcgRawData(ecgItem);
            ecg.clearAll();
            ecg.drawCurve(ecgItem,false);

            let ecg1=this.ecgView1;
            let ecgItem1=anotherEcg.slice(1750,3500);
            ecg1.setEcgRawData(ecgItem1);
            ecg1.clearAll();
            ecg1.drawCurve(ecgItem1,false);

            let ecg2=this.ecgView2;
            let ecgItem2=anotherEcg.slice(3500,5250);
            ecg2.setEcgRawData(ecgItem2);
            ecg2.clearAll();
            ecg2.drawCurve(ecgItem2,false);

            let ecg3=this.ecgView3;
            let ecgItem3=anotherEcg.slice(5250,7000);
            ecg3.setEcgRawData(ecgItem3);
            ecg3.clearAll();
            ecg3.drawCurve(ecgItem3,false);
        },
        saveToPc(){
            this.printOut(this.ecgTime);
        },
        saveRawData(){
            this.ExportData(this.ecgTime);
        },
        saveOtherRawData(){
            window.location.href="http://api7.iwown.com/dong2cal/";
        },
        ExportData(time){
            var elementA = document.createElement('a');
            elementA.setAttribute('href', 'data:text/plain;charset=utf-8,' + [this.ecgDeviceData]);

            elementA.download =time+".txt";
            // elementA.setAttribute('download', +timeStr+ ".txt");
            elementA.style.display = 'none';
            document.body.appendChild(elementA);
            elementA.click();
            document.body.removeChild(elementA);
        },
        dataURLToBlob(dataurl) {//ie 图片转格式
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type: mime})
        },
        downloadResult(name) {
            // let canvasID = document.body
            let canvasID = document.getElementById("dialog_view");
            let a = document.createElement('a');
            html2canvas(canvasID).then(canvas => {
                let dom = document.body.appendChild(canvas);
                // let scllowBar = dom.getElementById("scrollbar_view");
                dom.style.display = "none";
                a.style.display = "none";
                document.body.removeChild(dom);
                // main.style.width = "120px";
                // scllowBar.heigh=800;
                let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                a.setAttribute("href", URL.createObjectURL(blob));
                a.setAttribute("download", name + ".png")
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(blob);
                document.body.removeChild(a);
            });
        },
        printOut(name) {
            // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
            document.body.scrollTop = 0; // IE的
            document.documentElement.scrollTop = 0; // 其他
            this.downloadResult(name)
        },


    },
    mounted(){
        const that=this;
        this.showMask = this.value;
        this.loadECGView();
    },
    watch:{
        value(newVal){
            this.showMask = newVal;
            this.cancelDialog=newVal;
        },
        showMask(val) {
            this.$emit('input', val);
        },
        cancelDialog(){
            this.$emit('cancel');
        },
        flag(){
            this.ecgView.setCanvasSize(window.document.documentElement.clientWidth * 0.8, window.document.documentElement.clientHeight * 0.9 * 0.18);
            this.ecgView1.setCanvasSize(window.document.documentElement.clientWidth * 0.8, window.document.documentElement.clientHeight * 0.9 * 0.18);
            this.ecgView2.setCanvasSize(window.document.documentElement.clientWidth * 0.8, window.document.documentElement.clientHeight * 0.9 * 0.18);
            this.ecgView3.setCanvasSize(window.document.documentElement.clientWidth * 0.8, window.document.documentElement.clientHeight * 0.9 * 0.18);
            this.loadEcgDataDialog();
        },

    },
}
</script>
<style lang="less" scoped>
@import "../../views/style/base.less";
.dialog{
    position: fixed;
    display: flex;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    .dialog-container{
        width: 90%;
        height: 100%;
        background: #ffffff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: relative;
        .dialog-title{
            /*width: 100%;*/
            height: 60px;
            font-size: 18px;
            color: #696969;
            font-weight: 600;
            text-align: center;
            padding: 16px 50px 0 20px;
            box-sizing: border-box;
        }
        .content{
            /*box-sizing: border-box;*/
            /*width: 100%;*/
            height: 160px;
            background-color: #ffffff;
            text-align: center;
        }
        /*.inp{*/
            /*margin: 10px 0 0 20px;*/
            /*width: 200px;*/
            /*height: 40px;*/
            /*padding-left: 4px;*/
            /*border-radius: 4px;*/
            /*border: none;*/
            /*background: #efefef;*/
            /*outline: none;*/
            /*&:focus{*/
                /*border: 1px solid #509EE3;*/
            /*}*/
        /*}*/
        .btns{
            width: 100%;
            height: 60px;
            // line-height: 60px;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: right;
            padding: 0 16px;
            box-sizing: border-box;
            & > div{
                display: inline-flex;
                height: 40px;
                line-height: 40px;
                padding: 0 14px;
                color: #ffffff;
                background: #f1f1f1;
                border-radius: 8px;
                margin-right: 12px;
                cursor: pointer;
            }
            .default-btn{
                color: #787878;
                &:hover{
                    color: #509EE3;
                }
            }
        }
        .close-btn{
            position: absolute;
            top: 16px;
            right: 16px;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 18px;
            cursor: pointer;
            &:hover{
                font-weight: 600;
            }
        }

        .dismiss-dialog{
            width: 20px;
            height: 20px;
        }

        .title_line{
            background-color: #E5E5E5;
            width: 100%;
            height: 1px;
        }
        .title_line_1{
            background-color: #52BA9F;
            width: 100%;
            height: 3px;
        }
    }
}

.ecg_p_text_1{
    padding-left: .5rem;
    text-align: center;
}
.ecg_p_text_2{
    padding-left: .5rem;
    color: #999999 ;
    text-align: center;
}

.ecg_p_text_3{
    padding-left: .5rem;
    text-align: center;
}
.ecg_p_text_4{
    padding-left: .8rem;
    text-align: center;
}
.top_layout{
    text-align: center;
    align-items: center;
    padding-top: .2rem;
}

.right_layout{
    text-align: center;
    align-items: center;
    padding-top: .5rem;
    padding-right: .5rem;
}

.ecg_p_ai_result_1{
    margin-left: .5rem;
    margin-top: .5rem;
    color: #999999 ;
}
.my-scroll-bar{
    margin-top:50px;
    height: 70%;
}
</style>